import initialCameraProps from 'helpers/cameras/initialCameraProps'

export default function addMultiImagerLens(state, action) {
  const { lens: { id, name, location, heading, imagerId, fixed, ptz } } = action
  const camera = Object.assign(
    {},
    initialCameraProps(id, !state.ui.isImperial),
    { active: false, name, location, heading, imagerId },
    fixed && { isFixedImager: true },
    ptz && { isPtzImager: true }
  )

  return Object.assign({}, state, {
    cameras: [
      ...state.cameras,
      camera
    ]
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addMultiImagerLens.js